import { render, staticRenderFns } from "./ResourcePopup.vue?vue&type=template&id=4d297d6b&scoped=true"
import script from "./ResourcePopup.vue?vue&type=script&lang=js"
export * from "./ResourcePopup.vue?vue&type=script&lang=js"
import style0 from "./ResourcePopup.vue?vue&type=style&index=0&id=4d297d6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d297d6b",
  null
  
)

export default component.exports